(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('ContratosCtrl', ContratosCtrl);

  ContratosCtrl.$inject = [
    'LoadingService',
    'MessagesService',
    '$rootScope',
    'ContratosService',
    'AtividadesService',
    '$uibModal',
    '$scope'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function ContratosCtrl(LoadingService, MessagesService, $rootScope, ContratosService,
    AtividadesService, $uibModal, $scope) {
    const vm = this;

    // Controller data
    vm.loading = true;
    vm.itensContratos = [];
    vm.safra = null;
    vm.atividades = [];
    vm.atividade = null;
    vm.gleba = null;
    vm.scheduleForDuplication = null;
    vm.contratoGlebas = [];

    // Bindable methods
    vm.loadContratos = loadContratos;
    vm.assignGlebas = assignGlebas;

    // Function declarations
    function loadAtividades() {
      return AtividadesService.listComEmpreendimento()
        .then(({ data }) => {
          vm.atividades = data;
        });
    }

    function loadContratos() {
      vm.loading = true;
      vm.itensContratos = [];

      return ContratosService.listItems({
        safra: vm.safra.id,
        propriedade: $rootScope.currentPropriedade.id,
        atividade: _.get(vm.atividade, 'id'),
        gleba: _.get(vm.gleba, 'id')
      })
        .then((data) => {
          vm.itensContratos = data.data;
        })
        .catch((error) => {
          MessagesService.alert('Erro ao carregar contratos, tente novamente mais tarde');
          console.error(error);
        })
        .finally(() => {
          vm.loading = false;
        });
    }

    function assignGlebas(itemContrato) {
      vm.scheduleForDuplication = itemContrato;
      vm.contratoGlebas = itemContrato.glebas;
      const modal = $uibModal.open({
        scope: $scope,
        templateUrl: 'views/contratos/assign-glebas.html'
      });
      modal.result
        .then(() => {
          LoadingService.showLoading();
          return ContratosService.assignGlebas(itemContrato.id, _.flatMap(vm.contratoGlebas, 'id'));
        })
        .then(() => {
          loadContratos();
        })
        .catch((error) => {
          if (error && typeof error !== 'string') {
            MessagesService.alert('Erro ao atribuir os talhões ao contrato, tente novamente mais tarde.');
            console.error(error);
          }
        })
        .finally(() => {
          vm.duplicationTargets = [];
          LoadingService.hideLoading();
        });
      modal.closed.then(() => {
        vm.scheduleForDuplication = null;
      });
    }


    // Controller logic
    LoadingService.showLoading();
    $rootScope.initialize
      .then(() => {
        $rootScope.bodyClass = 'gray-bg';
        vm.safra = _.find($rootScope.safras, 'current');
        return loadAtividades();
      })
      .then(loadContratos)
      .catch(() => {
        $rootScope.errorRootInitialize();
      })
      .finally(LoadingService.hideLoading);
  }
}());
